import React, { useState, useEffect, useRef } from 'react'
import { useParams, useNavigate } from 'react-router-dom';
import { Button, Form }  from 'react-bootstrap';
import {  useSelector, useDispatch } from 'react-redux'
import { LinkContainer } from 'react-router-bootstrap';
import { useGetPublicplanQuery } from '../../slices/teachers/planApiSlice';
import { useSubscribeMutation, useGetProfileQuery, useUpdateMutation, useCheckstripeupgradesubscriptionMutation, useSubscribeinstripeMutation } from '../../slices/students/studentsApiSlice';
import { setStudentCredentials } from '../../slices/students/authStudentSlice';
import { toast } from 'react-toastify';
import StudentHeader from '../../components/StudentHeader';
import StudentNavbar from '../../components/StudentNavbar';
import Loader from '../../components/Loader';
import Message from '../../components/Message';
import PublicPlan from '../../components/PublicPlan';

const StudentAfterUpgradePayment = () => {

    const { id } = useParams();    
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const { studentInfo } = useSelector((state) => state.authStudent);

    const [cancelid, setCancelid] = useState();
    const [qleft, setQleft] = useState();
    const [stripeid, setStripeid] = useState();

    const { data: plansData, error: plansError, isLoading: plansIsLoading } = useGetPublicplanQuery(id);


    useEffect(() => {
        if(studentInfo && plansData) {
            studentInfo?.questions.map((pla) => {                                                                                
                if (pla.subject == plansData?.plan.subject && pla.plan == id && pla.subProcessing == true) {
                    setStripeid(pla.stripe_subscription_id)                    
                }

                if (pla.subject == plansData?.plan.subject && pla.renewal == true && pla.plan != id) {
                    setCancelid(pla.stripe_subscription_id)
                    setQleft(pla.questionsLeft)
                }

                if (pla.subject == plansData?.plan.subject && pla.renewal == false && pla.active == true &&  pla.questionsLeft > 0  && pla.plan != id) {
                    setCancelid(pla.stripe_subscription_id)
                    setQleft(pla.questionsLeft)
                }

                if (pla.subject == plansData?.plan.subject && pla.plan == id && pla.pastDue == true) {
                    setCancelid('none');
                    setQleft(pla.questionsLeft)
                }            
            });
        }
    }, [studentInfo, plansData])



    const [checkstripeupgradesubscription, { data2, error2, isLoading2 }] = useCheckstripeupgradesubscriptionMutation();

    useEffect( () => {
        if (studentInfo && cancelid && qleft != undefined && stripeid) {
            const fetchData = async () => {
                const res =  await checkstripeupgradesubscription({id, cancelid, qleft, stripeid}).unwrap();
                dispatch(setStudentCredentials({ ...res.updatedStudent }));
            }
            fetchData();
        }
        setTimeout(() => {
            navigate("/studentasknew");
            console.log('navigating to studentasknew');
          }, 4000);
    }, [studentInfo, cancelid, qleft, stripeid])

  return (
    <div>
        <StudentNavbar />
        <div className="main-content" id="panel">
            <StudentHeader /><br /><br />
            <div className="container-fluid mt--5 loginResponsive"><br />  
                <Loader />
            </div>
        </div>      
    </div>
  )
}

export default StudentAfterUpgradePayment
